import React from 'react';
import { 
  HelpCircle, 
  TrendingUp, 
  DollarSign, 
  Scissors, 
  BarChart, 
  Briefcase, 
  FileText, 
  Lightbulb
} from 'lucide-react';

/**
 * Компонент с полезными советами по оптимизации рентабельности
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: TrendingUp,
      title: 'Маржинальность',
      description: 'Повышайте маржинальность за счет оптимизации ассортимента. Сосредоточьтесь на товарах/услугах с высокой доходностью.'
    },
    {
      icon: Scissors,
      title: 'Снижение затрат',
      description: 'Регулярно пересматривайте операционные расходы. Сокращайте непроизводственные затраты, не влияющие на качество.'
    },
    {
      icon: DollarSign,
      title: 'Ценовая политика',
      description: 'Используйте гибкую ценовую политику. Анализируйте эластичность спроса и корректируйте цены для максимизации прибыли.'
    },
    {
      icon: BarChart,
      title: 'Анализ показателей',
      description: 'Отслеживайте ключевые показатели ежемесячно. Это поможет своевременно выявлять проблемы и принимать решения.'
    },
    {
      icon: Briefcase,
      title: 'Диверсификация',
      description: 'Рассматривайте возможности диверсификации бизнеса для снижения рисков и повышения рентабельности в долгосрочной перспективе.'
    },
    {
      icon: FileText,
      title: 'Налоговое планирование',
      description: 'Используйте все доступные легальные способы оптимизации налогообложения в соответствии с российским законодательством.'
    },
    {
      icon: Lightbulb,
      title: 'Автоматизация',
      description: 'Внедряйте автоматизацию бизнес-процессов для сокращения расходов на оплату труда и минимизации ошибок.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-emerald-500" />
        Советы по повышению рентабельности
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-emerald-700 dark:text-emerald-300 mb-2">
              Бесплатный анализ бизнеса
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400 mb-3">
              Получите подробный анализ вашего бизнеса с рекомендациями по повышению рентабельности от экспертов.
            </p>
            <button className="w-full py-1.5 text-xs bg-emerald-500 text-white rounded hover:bg-emerald-600 transition-colors">
              Получить консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;